/**
 * SelectViewButton component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Props for the SelectViewButton component.
 */
type Props = {
  focused: boolean;
};

/**
 * Styled select view button.
 */
const SelectViewButton = styled.button<Props>`
  background: ${(props) => (props.focused ? 'white' : 'none')};
  border: ${3 * Screen.widthRatio}px solid white;
  border-radius: ${50 * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? 'black' : 'white')};
  cursor: pointer;
  position: relative;
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  bottom: ${120 * Screen.widthRatio}px;
  height: ${60 * Screen.widthRatio}px;
  width: ${260 * Screen.widthRatio}px;

  &:hover {
    background: white;
    color: black;
  }
`;

export default SelectViewButton;
